import React from 'react';

export const IntakeFormDisabled: React.FC = () => {
    return <div></div>;
};
